import React, { useState } from 'react';
import { addSurveyData } from '@/services/survey.service';
import { updateStorageObject } from '@/utils/global';
import { Mixpanel } from '@/utils/mixpanel';
import { surveyForm2V2Validation } from '@/utils/validationSchema';
import { NotificationManager } from 'react-notifications';

import { useFormValidation } from '@/hooks/useFormValidation';
import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import RightArrow from '@/components/Icons/icons/RightArrow';

import { useSurveyContext } from '../surveyContext';
import TickIcon2 from '@/components/Icons/icons/TickIcon2';

const ObjectiveOptions = [
  { label: 'Seeding / Gifting', value: 'Seeding / Gifting' },
  { label: 'Paid Promotions', value: 'Paid Promotions' },
  { label: 'Getting UGC', value: 'I need UGC' },
  { label: 'Ambassador Program', value: 'Ambassador Program' },
  { label: 'Still figuring out', value: 'Still figuring out' },
];
const SurveyPage2V2 = () => {
  const { setSurveyFormStep, form2V2Data, setForm2V2Data, form1V2Data } = useSurveyContext();

  const {
    errors,
    setErrors,
    validate,
  }: { errors: any; setErrors: React.Dispatch<React.SetStateAction<{}>>; validate: any } =
    useFormValidation(surveyForm2V2Validation);

  const [isLoading, setIsLoading] = useState(false);

  const onFormSubmit = async (e: { preventDefault: () => void }) => {
    e?.preventDefault();
    const isValid = validate(form2V2Data);
    if (!isValid) return;

    const response = await addSurveyData({ ...form1V2Data, ...form2V2Data });
    Mixpanel.track('onboarding_step_completed', {
      'Step Name': 'Second Step',
      'Step Number': 2,
      Responses: form2V2Data,
    });
    if (response?.status) {
      //@ts-ignore
      setSurveyFormStep(7);
    } else {
      NotificationManager.error('Something Went Wrong', '', 1500);
    }
    setIsLoading(false);

    updateStorageObject('onboarding-form-data', 'form2V2', form2V2Data);
  };

  return (
    <form onSubmit={onFormSubmit}>
      <div className="survey-v2-2-container">
        <div className="survey-2-content">
          <div className="survey-2-form">
            <div className="survey-2-question">
              <CustomButtonSelectInputV2
                title="What is your primary objective with SARAL and influencer marketing?"
                subTitle=""
                options={ObjectiveOptions}
                value={form2V2Data.objective}
                //@ts-ignore
                onSelect={(o: any) => {
                  setErrors((e) => ({ ...e, objective: null }));
                  //@ts-ignore
                  setForm2V2Data((p) => ({ ...p, objective: o }));
                }}
                error={errors.objective}
                disabled={isLoading}
              />
            </div>
            <div className="survey-2-bottom-container">
              <ButtonComponent style={{ flex: 2 }} type="submit">
                Next <RightArrow color="#fff" />
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

interface CustomButtonSelectInputInterface {
  title: string;
  subTitle: string;
  options: Array<any>;
  onSelect: () => {};
  disabled: boolean;
  value: string;
  error: string;
}

const CustomButtonSelectInputV2 = ({
  title,
  subTitle,
  options,
  onSelect,
  disabled,
  value,
  error,
}: CustomButtonSelectInputInterface) => {
  return (
    <div className="custom-button-select-input-container-v2">
      <div className="custom-button-select-input-title-container">
        <div className="custom-button-select-input-title">{title}</div>
        {subTitle && <div className="custom-button-select-input-sub-title">{subTitle}</div>}
      </div>
      <div className="custom-button-select-input-option-container">
        {options.map((option) => (
          <div
            className={`option-button ${option.value === value ? 'option-button-active' : ''}`}
            key={option.value}
            onClick={() => {
              if (disabled) return;
              //@ts-ignore
              onSelect(option.value);
            }}>
            <span>{option.label}</span>
            <div>{option.value === value && <TickIcon2 color="var(--text-highlight)" width={12} height={12} />}</div>
          </div>
        ))}
      </div>
      {error && <div className="survey-error-text">{error}</div>}
    </div>
  );
};

export default SurveyPage2V2;
